/**
 * Enum for terminal transaction result.
 * @readonly
 * @enum {Object} TerminalTransactionResultEnum
 */

const TerminalTransactionResultEnum = {
  APPROVED                 : {Id: 1, Code: 'APPROVED'},
  DECLINED                 : {Id: 2, Code: 'DECLINED'},
  CANCELLED                : {Id: 3, Code: 'CANCELLED'},
  FAILED                   : {Id: 4, Code: 'FAILED'},
  UNKNOWN                  : {Id: 5, Code: 'UNKNOWN'},
  BUSY                     : {Id: 6, Code: 'BUSY'},
  MAX_TRANSACTIONS         : {Id: 7, Code: 'MAX_TRANSACTIONS'},
  JOB_MAX_ATTEMPTS_EXCEEDED: {Id: 0, Code: 'JOB_MAX_ATTEMPTS_EXCEEDED'},
  ERROR                    : {Id: -1, Code: 'ERROR'}
}

export default TerminalTransactionResultEnum
